// extracted by mini-css-extract-plugin
export var closeButton = "video-modal-module--close-button--nYT6-";
export var modal = "video-modal-module--modal--FtbWX";